module.exports = __webpack_public_path__ + "img/vasectomy_x2.d891158f.png";